import {BaseEntity,Column,Entity,Index,JoinColumn,JoinTable,ManyToMany,ManyToOne,OneToMany,OneToOne,PrimaryColumn,PrimaryGeneratedColumn,RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn} from "typeorm";
import {EmployeeDetails} from '../employee-details/employee-details.entity';
@Entity('employee_cashbook')
export class EmployeeCashbook{
  @PrimaryGeneratedColumn("increment",{name:'cashbook_id'})
  cashbookId:number;

  @Column("int",{
    nullable: false,
    name:"emp_id"
    })
  empId:number;

  @Column("varchar",{
    nullable: false,
    length:10,
    name:"amount"
    })
    amount:string;

    @Column("date",{
        nullable:false,
        name:"activity_date"
      })
      activityDate:Date;

  @Column("boolean",{
    nullable:false,
    default:true,
    name:"status"
    })
  status:boolean;
  @CreateDateColumn({
    name: "created_at",
    type:"datetime"
  })
  createdAt: Date;

  @Column("int", {
      nullable: false,
      name: "created_user"
  })
  createdUser: number | null;


  @UpdateDateColumn({
      name: "updated_at",
      type:'datetime'
  })
  updatedAt: Date;

  @Column("int", {
      nullable: true,
      name: "updated_user"
  })
  updatedUser: number | null;


  @VersionColumn({
      default:1,
      name: "version_flag"
  })
  versionFlag: number;
  @ManyToOne(type=> EmployeeDetails, employeeDetails => employeeDetails.cashbook,{  nullable:false, }) // specify inverse side as a second parameter
    @JoinColumn({ name:"emp_id"})
    cashbook: EmployeeDetails;
}